/**
 * Light or dark, remembered. Light is the default because the card and
 * the board are modelled on printed tournament boards, and because
 * anyone entering scores on the 18th in June needs the contrast.
 */
const KEY = "postcard.theme";

export function initTheme() {
  const saved = localStorage.getItem(KEY);
  const mode = saved
    || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
  document.documentElement.setAttribute("data-theme", mode);
  return mode;
}

export function setTheme(mode) {
  localStorage.setItem(KEY, mode);
  document.documentElement.setAttribute("data-theme", mode);
  return mode;
}
